import React, { useState } from 'react';
import { apiFetch } from '../jscontrol/apiClient';
import '../css/Category.css';

const SettingCreate = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState({ Name: '', Value: '' });
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!form.Name.trim()) {
      setFormError('Name is required.');
      return;
    }
    setSaving(true);
    setFormError(null);
    try {
      await apiFetch('/Setting/Create', {
        method: 'POST',
        data: {
          Name: form.Name.trim(),
          Value: form.Value,
        },
      });
      onSuccess('Setting created successfully.');
    } catch (e) {
      setFormError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="cat-modal-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="cat-modal">
        <div className="cat-modal-header">
          <h5>Add Setting</h5>
          <button type="button" className="cat-modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="cat-modal-body">
          {formError && (
            <div className="alert alert-danger py-2 mb-3">{formError}</div>
          )}

          <div className="form-group mb-3">
            <label className="form-label">
              Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              name="Name"
              value={form.Name}
              onChange={handleChange}
              placeholder="e.g. SiteTitle"
            />
          </div>

          <div className="form-group mb-3">
            <label className="form-label">Value</label>
            <textarea
              className="form-control"
              name="Value"
              value={form.Value}
              onChange={handleChange}
              rows={3}
              placeholder="Setting value"
            />
          </div>
        </div>

        <div className="cat-modal-footer">
          <button type="button" className="btn btn-light me-2" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                Saving...
              </>
            ) : (
              'Add Setting'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingCreate;
